"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.ServiceBox {\n  padding: 0;\n  min-height: 200px;\n  display: flex;\n  flex-flow: column;\n  border: solid 1px #e8e8e8; }\n  .ServiceBox .ServiceBox-Header {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 16px; }\n  .ServiceBox .ServiceBox-CheckBoxes {\n    margin-top: 24px; }\n  .ServiceBox .ServiceBox-Content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 16px 0 16px; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Title {\n      color: #e41b13; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Body {\n      display: flex;\n      flex-flow: column;\n      margin-top: 24px;\n      gap: 24px; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form {\n        display: flex;\n        gap: 30px; }\n        .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form .ServiceBox-CheckBoxes {\n          margin-top: 0; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-QueryTitle {\n        font-size: 14px;\n        font-weight: bold; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link {\n        align-self: flex-start; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link:focus {\n        outline: none; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Description p {\n      font-size: 14px;\n      line-height: 1.29;\n      color: #4c4c4c;\n      padding-right: 8px; }\n  .ServiceBox .ServiceBox-BtnsContainer {\n    display: flex;\n    margin-top: auto; }\n  .ServiceBox .checkbox {\n    margin-bottom: 0; }\n  .ServiceBox .ServiceBox-extended-margin {\n    margin-left: -16px;\n    margin-right: -16px; }\n  .ServiceBox .ServiceBox-Btn {\n    background-color: #a8a8a8;\n    display: flex;\n    width: 100%; }\n    .ServiceBox .ServiceBox-Btn a,\n    .ServiceBox .ServiceBox-Btn p {\n      padding: 16px;\n      color: #fff;\n      display: block;\n      text-decoration: none;\n      font-size: 14px;\n      line-height: 1.5;\n      flex: 1;\n      cursor: pointer; }\n    .ServiceBox .ServiceBox-Btn:hover {\n      background: #4c4c4c; }\n  .ServiceBox .ServiceBox-Btn__dark {\n    background-color: #4c4c4c; }\n    .ServiceBox .ServiceBox-Btn__dark:hover {\n      background-color: #000000; }\n  .ServiceBox .ServiceBox-Btn__red:hover {\n    background-color: #e41b13; }\n  .ServiceBox .ServiceBox-Btn__disabled {\n    background: #d4d4d4;\n    border-color: #d4d4d4;\n    color: #ffffff; }\n    .ServiceBox .ServiceBox-Btn__disabled p:hover {\n      cursor: not-allowed;\n      background: #a8a8a8; }\n\n.ServiceBox-Subscribed {\n  background-color: #f4f4f4; }\n";
  const fileName = "ButtonsContainer_ServiceSubscriptionBox";
  const element = document.querySelector("style[data-sass-component='ButtonsContainer_ServiceSubscriptionBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function ButtonsContainer(props) {
  const {
    type,
    isSubscribed,
    isCancelled,
    onManage,
    onSubscribe,
    onUnsubscribe,
    onSave,
    translate,
    className,
    isFormValid,
    updateSubscription
  } = props;
  let buttons = null;
  switch (type) {
    case 0:
      {
        buttons = /*#__PURE__*/_react.default.createElement("div", {
          onClick: onManage,
          className: "ServiceBox-Btn ServiceBox-Btn"
        }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.manage')));
        break;
      }
    case 1:
    case 2:
      {
        if (!isSubscribed) {
          buttons = /*#__PURE__*/_react.default.createElement("div", {
            onClick: onSubscribe,
            className: "ServiceBox-Btn ServiceBox-Btn"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.subscribe')));
        }
        if (isSubscribed && !isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            onClick: onManage,
            className: "ServiceBox-Btn ServiceBox-Btn__dark"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.manage'))), /*#__PURE__*/_react.default.createElement("div", {
            onClick: onUnsubscribe,
            className: 'ServiceBox-Btn ServiceBox-Btn__red'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe'))));
        }
        if (isSubscribed && isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            onClick: onManage,
            className: "ServiceBox-Btn ServiceBox-Btn__dark"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.manage'))), /*#__PURE__*/_react.default.createElement("div", {
            onClick: null,
            className: 'ServiceBox-Btn ServiceBox-Btn__disabled'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe'))));
        }
        break;
      }
    case 3:
      {
        if (!isSubscribed) {
          buttons = /*#__PURE__*/_react.default.createElement("div", {
            onClick: onSubscribe,
            className: "ServiceBox-Btn ServiceBox-Btn"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.subscribe')));
        }
        if (isSubscribed && !isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement("div", {
            onClick: onUnsubscribe,
            className: 'ServiceBox-Btn ServiceBox-Btn__red'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe')));
        }
        if (isSubscribed && isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement("div", {
            onClick: null,
            className: 'ServiceBox-Btn ServiceBox-Btn__disabled'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe')));
        }
        break;
      }
    case 4:
    case 5:
      {
        buttons = /*#__PURE__*/_react.default.createElement("div", {
          onClick: onSave || null,
          className: "ServiceBox-Btn ServiceBox-Btn"
        }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.save')));
        break;
      }
    case 6:
    case 7:
      {
        if (!isSubscribed) {
          buttons = /*#__PURE__*/_react.default.createElement("div", {
            onClick: isFormValid ? onSubscribe : null,
            className: `ServiceBox-Btn ${isFormValid ? '' : 'ServiceBox-Btn__disabled'}`
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.subscribe')));
        }
        if (isSubscribed && !isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            onClick: onManage,
            className: "ServiceBox-Btn ServiceBox-Btn__dark"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.manage'))), updateSubscription ? /*#__PURE__*/_react.default.createElement("div", {
            onClick: onSave,
            className: `ServiceBox-Btn ${isFormValid ? '' : 'ServiceBox-Btn__disabled'}`
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.save'))) : /*#__PURE__*/_react.default.createElement("div", {
            onClick: onUnsubscribe,
            className: 'ServiceBox-Btn ServiceBox-Btn__red'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe'))));
        }
        if (isSubscribed && isCancelled) {
          buttons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
            onClick: onManage,
            className: "ServiceBox-Btn ServiceBox-Btn__dark"
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.manage'))), /*#__PURE__*/_react.default.createElement("div", {
            onClick: null,
            className: 'ServiceBox-Btn ServiceBox-Btn__disabled'
          }, /*#__PURE__*/_react.default.createElement("p", null, translate('subscriptionBox.button.unsubscribe'))));
        }
        break;
      }
    default:
      break;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: ['ServiceBox-BtnsContainer'].concat(className).join(' ')
  }, buttons);
}
var _default = exports.default = ButtonsContainer;